import React from "react";
import { Container, Section, PageHero, Card, Eyebrow, CTABand } from "@/components/ui-bits/Primitives";
import { PRODUCTS, IMAGES } from "@/lib/site-data";
import { CheckCircle2 } from "lucide-react";

export default function Products() {
    return (
        <div data-testid="products-page">
            <PageHero
                kicker="Products & Technology"
                title="Hardware we trust, deployed at scale."
                lead="We engineer multi-vendor sites around the best-fit equipment for each mission — from corridor DC fast to workplace Level 2."
                image={IMAGES.chargingPark}
            />

            <Section>
                <Container>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {PRODUCTS.map((p, i) => (
                            <Card key={p.name} data-testid={`product-card-${i}`} className="!p-0 overflow-hidden">
                                <div className="relative aspect-[16/10] overflow-hidden">
                                    <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-ink-900/80 to-transparent" />
                                    <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.22em] text-electric-400 bg-ink-900/70 border border-electric-400/40 px-2 py-1">{p.category}</div>
                                </div>
                                <div className="p-8">
                                    <h3 className="font-heading font-medium text-2xl text-white">{p.name}</h3>
                                    <ul className="mt-6 space-y-2.5 border-t border-white/10 pt-6">
                                        {p.specs.map((s) => (
                                            <li key={s} className="flex items-start gap-2 text-sm text-slate-300">
                                                <CheckCircle2 className="w-4 h-4 text-electric-400 mt-0.5 shrink-0" /> {s}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Card>
                        ))}
                    </div>

                    <div className="mt-16 border border-white/10 p-8 md:p-12 bg-ink-700/40">
                        <Eyebrow className="mb-3">Vendor-Neutral</Eyebrow>
                        <h3 className="font-heading text-2xl md:text-3xl text-white tracking-tight leading-tight max-w-3xl">We deploy what works for the site — not what's on the shelf.</h3>
                        <p className="mt-4 text-slate-400 leading-relaxed max-w-3xl">Our deployments combine equipment from leading OEMs based on power requirements, footprint constraints, American-vendor sourcing, and operational fit. All sites speak OCPP and integrate into a single host-facing dashboard.</p>
                    </div>
                </Container>
            </Section>

            <CTABand title="Looking for a specific charger spec?" subtitle="Tell us your kW target, parking layout, and electrical service — we'll spec the right equipment." />
        </div>
    );
}
